import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";


export interface PageLoginProps {
  className?: string;
}


const ReservationHead: FC<PageLoginProps> = ({ className = "" }) => {
	
	return (
		<>
			<div
				className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
			>
				<div
					className={`max-w-2xl`}
				>
					<h2 className={`text-xl md:text-2xl font-semibold`}>
						예약현황
					</h2>
				</div>
			</div>
		</>
  	);
};

export default ReservationHead;
